
import api from "../api";

const getEvents = async (status) => {
    try{
     const response = await api.get("/events",{
        params: status ? {status} :{},
     });
     return response.data;
}catch(error){
    throw error;
}}

const getEventById = async (id) =>{
    try{
    const response = await api.get(`/events/${id}`);
    return response.data;
}catch(error){
    throw error;
}
}
export {getEvents, getEventById};